$(document).ready(function () {
    var $menuItems = $('.js-partner-hubs-menu');
    if (!$menuItems.length) {
        return;
    }

    var headers = Object.assign({}, window.$headerAuth || {});
    var userId = localStorage.getItem('user_id');
    if (userId) {
        headers['X-User-Id'] = userId;
    }

    $.ajax({
        url: '/api/partner-hubs?per_page=1',
        method: 'GET',
        dataType: 'json',
        headers: headers,
        global: false
    }).done(function (result) {
        if (result && result.total > 0) {
            $menuItems.css('display', '');
        }
    });
});
